import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translations/en";
import ar from "./translations/ar";

i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    en: en,
    ar: ar,
  },
  fallbackLng: "en",
  debug: false,
  lng: localStorage.getItem("lang") ? localStorage.getItem("lang") : "en",
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },

  react: {
    useSuspense: true
  },
});

export default i18n;
